<template>
    <tr>
        <td><input type="checkbox" v-model="checked"></td>
        <td v-if="featured"><input type="radio" v-model="select"></td>
        <td>
            <template v-if="!image.url">
                <button type="button" class="button white button-small" @click="openFiles = true">Selecinar image</button>
                
            </template>
            <template v-else>
                <div class="flex-middle">
                    <img :src="image.url" width="35" style="margin-right: 5px">
                    <button type="button" class="button white button-small" @click="openFiles = true"><i class="ico-cached"></i></button>
                </div>
            </template>
            <modal :show="openFiles" v-model="openFiles" :class="'modal-lg'">
                <div slot="body">
                    <files-management :callback="fill"></files-management>
                </div>
            </modal>
        </td>
    </tr>
</template>
<script>
import FilesManagement from '../../components/FilesManagement'
import Modal from '../../components/Modal.vue'
export default {
   name: "Image",
   components: {
       Modal,
       FilesManagement
   },
   data(){
       return {
           checked: false,
           select: false,
           openFiles: false
       }
   },
   watch: {
        'checked': {
            deep: true,
            handler(){
                if(this.list){
                    console.log(this.index)
                    this.doList(this.index)
                }
            }
        }
   },
   mounted(){
       if(this.list){
           if(this.list.includes(this.index)){
               this.checked = true
           }
       }
   },
   props: {
       index: {
           type: Number,
           required: true
       },
       image: {
           type: Object,
           required: false
       },
       callback: {
           type: Function,
           required: true
       },
       featured: {
           type: Boolean,
           required: false
       },
       list: {
           type: Array,
           required: false
       },
       doList: {
           type: Function,
           required: false
       }
   },
   methods: {

       fill(img){
           this.image = img
           this.openFiles = false
        //    this.image = img
           this.callback(img, this.index)
       }
   }
}
</script>